import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { format } from 'date-fns';
import { parseISO } from 'date-fns';
import { authenticateUser } from '../js/index';

const Bulletins = () => {
    const [bulletinList, setBulletinList] = useState([]);
    const [currentBulletin, setCurrentBulletin] = useState('');
    const [currentBulletinIndex, setCurrentBulletinIndex] = useState(0);
    const [fade, setFade] = useState(true);
    const [lastInteraction, setLastInteraction] = useState(Date.now());

    const [userData, setUserData] = useState({});

    const [newBulletin, setNewBulletin] = useState(false);
    const [bulletin, setBulletin] = useState({
        title: '',
        date: new Date().toISOString().split('T')[0],
        category: '',
        author: '',
        content: '',
        expiration: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0], // Default expiration 7 days from now
    });

    useEffect(() => {
        const getUser = async () => {
            const user = await authenticateUser();
            if (user) setUserData(user);
        };
        getUser();

        const fetchBulletins = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/bulletins`, { withCredentials: true });
            if (response.status === 200) {
                setBulletinList(response.data);
            }
        };
        fetchBulletins();
    }, []);

    useEffect(() => {
        if (newBulletin) {
            setBulletin({
                title: '',
                date: new Date().toISOString().split('T')[0],
                category: '',
                author: `${userData.firstName} ${userData.lastName}`,
                content: '',
                expiration: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0], // Default expiration 7 days from now
            });
        }
    }, [newBulletin]);
    
    useEffect(() => {
        if (bulletinList && bulletinList[currentBulletinIndex] && bulletinList[currentBulletinIndex].photos && bulletinList.length > 0) {
            const interval = setInterval(() => {
                setCurrentBulletinIndex((prevIndex) => 
                    (prevIndex + 1) % bulletinList[currentBulletinIndex].photos.length
                );
            }, 30000); // 30 seconds

            return () => clearInterval(interval);
        }
    }, [bulletin]);

    useEffect(() => {
        if (bulletinList && bulletinList.length > 0) {
            setCurrentBulletin(bulletinList[currentBulletinIndex]);
        } else {
            setCurrentBulletin('');
        }
    }, [bulletinList, currentBulletinIndex]);

    const resetBulletin = () => {
        setNewBulletin(false);
        setBulletin({
            title: '',
            date: new Date().toISOString().split('T')[0],
            category: '',
            author: `${userData.firstName} ${userData.lastName}`,
            content: '',
            expiration: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0], // Default expiration 7 days from now
        });
    };

    const onChange = (e) => {
        setBulletin({
            ...bulletin,
            [e.target.name]: e.target.value
        });
    };

    const changeCard = (updateFn) => {
        if (newBulletin) return;
        if (bulletinList.length < 2) return;

        setFade(false);

        setTimeout(() => {
            setCurrentBulletinIndex(updateFn);
            setFade(true);
        }, 600);
    };

    const prev = () => {
        changeCard((i) => (i > 0 ? i - 1 : bulletinList.length - 1));
        setLastInteraction(Date.now());
    };

    const next = () => {
        changeCard((i) => (i < bulletinList.length - 1 ? i + 1 : 0));
        setLastInteraction(Date.now());
    };

    useEffect(() => {
        if (newBulletin) return;

        const interval = setInterval(() => {
        const now = Date.now();
        if (now - lastInteraction > 30000) {
            changeCard((i) => (i < bulletinList.length - 1 ? i + 1 : 0));
        }
        }, 10000);

        return () => clearInterval(interval);
    }, [lastInteraction, bulletinList.length, newBulletin]);

    const deleteBulletin = async () => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/bulletins/delete/${currentBulletin.id}`, { withCredentials: true });
            if (response.status === 200) {
                setBulletinList(bulletinList.filter((_, i) => i !== currentBulletinIndex));
                setCurrentBulletinIndex(0);
            }
        } catch (error) {
            console.error('Error deleting bulletin:', error);
        }
    };

    const saveBulletin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/bulletins/add`, bulletin, { withCredentials: true });
            if (response.status === 201) {
                setBulletinList([...bulletinList, response.data.Bulletin]);
                resetBulletin();
            }
        } catch (error) {
            console.error('Error saving bulletin:', error);
        }
    };

    return (
        <div className='bulletin-section'>
            <h2>Bulletins</h2>
            <div className='bulletin-wrapper'>
                <div className={`bulletin-container serviceItem ${fade ? 'fade-in' : 'fade-out'}`}>
                    {bulletinList && bulletinList.length > 0 && !newBulletin && (
                        <button className='close-button' onClick={deleteBulletin}>
                            <img src="../icons/x.svg" alt="Close" />
                        </button>
                    )}
                    {!newBulletin && bulletinList && bulletinList.length > 1 && (
                        <>
                            <button id='left-chevron' className='chevrons-dark' onClick={prev}><img src="../icons/chevron-left.svg" alt="Previous" /></button>
                            <button id='right-chevron' className='chevrons-dark' onClick={next}><img src="../icons/chevron-right.svg" alt="Next" /></button>
                            <div id='carouselIndicators'>
                                {bulletinList.length > 1 && bulletinList.map((_, i) => (
                                    <span key={i} className={`indicator ${i === currentBulletinIndex ? 'active' : ''}`}></span>
                                ))}
                            </div>
                        </>
                    )}
                    {!newBulletin ? (
                        bulletinList && bulletinList.length > 0 ? (
                            <div className='bulletin-data'>
                                <div className='bulletin-header'>
                                    <span>{currentBulletin.category?.charAt(0).toUpperCase() + currentBulletin.category?.slice(1)}</span>
                                    <div className='title-container'>
                                        <h4 className='bulletin-title'>{currentBulletin.title}</h4>
                                        <span className='bulletin-author'>{currentBulletin.author}</span>
                                    </div>
                                    <span>{currentBulletin.date ? format(parseISO(currentBulletin.date), 'MM/dd/yyyy') : ''}</span>
                                </div>
                                <p className='bulletin-content'>{currentBulletin.content}</p>
                            </div>
                        ) : (
                            <div>No current bulletins</div>
                        )
                    ) : (
                        <form id="bulletin-form" action="addBulletin" onSubmit={saveBulletin}>
                            <div id='bulletin-inputs'>
                                <div id='bulletin-header-inputs'>
                                    <label htmlFor="category" className='flex-col'>Category
                                        <select name='category' value={bulletin.category} onChange={onChange}>
                                            <option value="">------</option>
                                            <option value="event">Event</option>
                                            <option value="advisory">Advisory</option>
                                            <option value="urgent">Urgent</option>
                                        </select>
                                    </label>
                                    <div className='title-author'>
                                        <label htmlFor="title">Title
                                            <input type="text" name='title' value={bulletin.title} onChange={onChange} />
                                        </label>
                                        <label htmlFor="author">Author
                                            <input type="text" name='author' value={bulletin.author} onChange={onChange} id='bulletin-author' />
                                        </label>
                                    </div>
                                    <div className='date-inputs'>
                                        <label htmlFor="date">Date
                                            <input type="date" name='date' value={bulletin.date} onChange={onChange} />
                                        </label>
                                        <label htmlFor="expiration">Expiration
                                            <input type="date" name='expiration' value={bulletin.expiration} onChange={onChange} />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <label htmlFor="content" className='flex-col'>Content
                                <textarea name='content' value={bulletin.content} onChange={onChange} id='bulletin-content' />
                            </label>
                        </form>
                    )}
                </div>
            </div>
            {userData.role === 'admin' && !newBulletin && <button className="add-bulletin-button" onClick={() => setNewBulletin(true)}>Add Bulletin</button>}
            {userData.role === 'admin' && newBulletin && (
                <div className='button-container'>
                    <button type='button' onClick={saveBulletin}>Save</button>
                    <button type='button' onClick={resetBulletin}>Cancel</button>
                </div>
            )}
        </div>
    );
};

export default Bulletins;